import script from "./OrganicRoom.vue?vue&type=script&setup=true&lang=js"
export * from "./OrganicRoom.vue?vue&type=script&setup=true&lang=js"

import "./OrganicRoom.vue?vue&type=style&index=0&id=2ec645e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ec645e2"]])

export default __exports__